import React from 'react';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime'
dayjs.extend(relativeTime);

export default class UserTable extends React.Component {

    render() {
        return (
            <table className="w-full text-md bg-white shadow-md rounded mb-4">
                <tbody>
                    <tr className="border-b">
                        <th className="text-left p-3 px-5">Name</th>
                        <th className="text-left p-3 px-5">Email</th>
                        <th className="text-left p-3 px-5">Last login</th>
                        <th className="text-left p-3 px-5">Role</th>
                    </tr>
                    {this.props.users.map(user => (
                        <tr className="border-b hover:bg-orange-100 bg-gray-100">
                            <td className="p-3 px-5">{user.firstName} {user.lastName}</td>
                            <td className="p-3 px-5">{user.email}</td>
                            <td className="p-3 px-5">{Boolean(user.lastLogin) ? dayjs(user.lastLogin).from(dayjs()) : 'N/A'}</td>
                            <td className="p-3 px-5">{user.admin ? 'Admin' : 'User'}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/user-table.js